// extracted by mini-css-extract-plugin
export default {"searchPageBodyWrapper":"searchPageBodyStyles_searchPageBodyWrapper__IPwEY"};